import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthStore } from './auth/services/auth.store';
import { AuthEndpoint } from './auth/services/auth.endpoint';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AuthStore, AuthEndpoint],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}
